import { Badge, LegacyStack, Text } from "@shopify/polaris";

import { Handle, Position } from "reactflow";

function ConsentNode({ id, data }) {
  return (
    <div
      className={"consent-node " + data.type}
      onClick={() => data.clickNode(id)}
    >
      <Handle type="target" position={Position.Left} />
      <br />
      <LegacyStack alignment="center">
        <Badge tone={data.type === "optin" ? "success" : "warning"}>
          {data.type === "optin" ? "Opt-in" : "Opt-out"}
        </Badge>
        <Text variant="bodySm">contact</Text>
      </LegacyStack>
      <br />
      <Handle type="source" position={Position.Right} />
    </div>
  );
}

export default ConsentNode;
